<template>
  <div class="pe-empty-comp">
    <img src="../assets/img_pe_empty@2x.png" />
    <div class="tip">{{ tip }}</div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
@Component({
  components: {},
})
export default class PEEmptyInfo extends BaseComponent {
  @Prop({ type: String, required: true })
  tip!: string
}
</script>
<style lang="less">
.pe-empty-comp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > img {
    width: 105px;
    height: 105px;
  }
  > .tip {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #8f8f8f;
  }
}
</style>
